import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardGuard implements CanActivate {

  constructor(public _authService: AuthService,
              public router: Router){}
  
  canActivate(){
    if (this._authService.isAuth()){
      return true;
    } else {
      console.log('BLOQUEADO POR EL LOGIN-GUARD');
      this.router.navigate(['/login']);
      return false;
    }
  }

//   adminGuard(){
//     console.log('Es Admin? ', this._authService.isAdmin());
//     if (this._authService.isAdmin()){
//       console.log('Pasó por Login-Guard');
//       return true;
//     } else {
//       console.log('BLOQUEADO POR EL LOGIN-GUARD');
//       this.router.navigate(['/login']);
//       return false;
//     }
// }
}
